export enum OrderStatus {
    One = 1,
    Two = 2
}

